module.exports = __webpack_public_path__ + "img/dataMiddleground-charafunction2.059747ee.png";